import { FlexBetween, FlexColumn, FlexStart } from '../../styles'
import { FlexCenter } from 'styles'
import { styled } from '@mui/material'
import { transientOptions } from 'styles/TransientOptions'

export const SelectWrap = styled(FlexColumn, transientOptions)`
  position: relative;
  width: 100%;
  height: 100%;
  padding-left: 12px;
  justify-content: center;
  background-color: #16191e;
  border-top-right-radius: 4px;
  border-top-left-radius: 4px;
`
export const SelectSelector = styled(FlexBetween)`
  align-items: center;
  font-weight: 600;
  font-size: 14px;
  cursor: pointer;
  height: 100%;
  border-top-right-radius: 4px;
  height: 56px;
  svg {
    margin-right: 17px;
  }

  .icon-img {
    width: 24px;
    height: 24px;
    border-radius: 50%;
    margin-right: 8px;
    display: inline-block;
  }

  .arrow {
    transition: all 0.4s ease;
  }
  &:hover {
    .arrow {
      color: ${(props) => props.theme.color.primary30};
    }
  }
  &.in {
    .arrow {
      color: ${(props) => props.theme.color.primary30};
      transform: rotate(-180deg);
    }
  }
`
export const TokenLise = styled('div')`
  max-height: 210px;
  overflow: auto;
  margin-top: 16px;
  /* border: 1px solid red; */
`
export const OptionItem = styled(FlexBetween)`
  font-size: 14px;
  height: 48px;
  padding: 12px 16px;
  box-sizing: border-box;
  line-height: 20px;
  font-weight: 600;
  cursor: pointer;
  color: rgba(229, 234, 238, 1);
  margin-bottom: 8px;
  &:hover {
    background-color: #394149;
  }

  &.active {
    border-left: 2px solid #a0ee09;
    background-color: rgba(160, 238, 9, 0.1);
    color: rgba(160, 238, 9, 1);
  }

  .left {
    display: flex;
    img {
      display: flex;
      width: 24px;
      height: 24px;
      margin-right: 6px;
      border-radius: 50%;
    }
  }

  .right {
  }

  /* span { */
  /* font-weight: 600;
    font-size: 16px;
  } */
  /* 
  .full-name {
    color: rgba(123, 136, 145, 1);
    font-size: 12px;
    margin-left: 5px;
    font-weight: 400;
  } */
`
export const SelectSelectorInfo = styled(FlexStart)`
  /* background-color: red; */
`

export const SelectorInfoRight = styled('div')`
  display: flex;
  margin-right: 12px;
  font-weight: 400;
  font-size: 12px;
  line-height: 20px;
  color: #9199b1;
  svg {
    margin-right: 0;
  }
`

export const SelectOptionsWrap = styled('div')<{ in: number }>`
  left: 0;
  /* padding: 8px 20px; */
  /* margin: 12px 0 0; */
  position: absolute;
  min-width: 100%;
  z-index: 10;
  background: ${(props) => props.theme.color.bg};
  border-top: ${(props) =>
    props?.in === 1
      ? '1px solid rgba(160, 238, 9, 1)'
      : '1px solid transparent'};
  border-bottom-left-radius: 6px;
  border-bottom-right-radius: 6px;
  box-shadow:
    0px 0px 2px rgba(0, 0, 0, 0.12),
    0px 10px 15px -3px rgba(0, 0, 0, 0.12),
    0px 4px 6px -2px rgba(0, 0, 0, 0.04);
  top: 100%;
  background-color: #2a3139;
  /* border: 1px solid #2a3139; */
`

export const FilterInput = styled('div')`
  display: block;
  height: 40px;
  position: relative;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  margin-top: 10px;
  margin-left: 16px;
  margin-right: 16px;

  @keyframes anim {
    0% {
      width: 0;
    }
    100% {
      width: 100%;
    }
  }

  &:focus-within {
    &::after {
      content: '';
      position: absolute;
      left: 0;
      width: 0;
      bottom: 0px;
      height: 1px;
      background-color: ${(props) => props.theme.color.primary30};
      animation: anim 0.3s ease-in-out;
      animation-fill-mode: forwards;
    }
  }
`

export const SearchInput = styled('input')`
  height: 40px;
  border: none;
  font-size: 14px;
  font-weight: 400;
  border-bottom: 1px solid ${(props) => props.theme.color.text20};
  box-sizing: border-box;
  background-color: transparent;
  color: rgba(255, 255, 255, 1);
  outline: none;
  width: 100%;
  padding: 0 16px 0 25px;
  &::placeholder {
    color: rgba(255, 255, 255, 1);
  }
`

export const SearchIcon = styled(FlexCenter)`
  width: 24px;
  position: absolute;
  left: 0;
  top: 50%;
  transform: translateY(-50%);
  .iconfont {
    margin-top: -2px;
    color: #fff;
  }
`
